import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  getdeliveryaddresses: option =>
    request('v1/deliveryaddress/getdeliveryaddresses', option, true, false), // 查询收件人地址列表
  getdeliveryaddress: option => {
    const urls = querystring(option)
    return request('v1/deliveryaddress/getdeliveryaddress' + urls, {}, true, false) // 查询收件人地址
  },
  adddeliveryaddress: option =>
    request('v1/deliveryaddress/adddeliveryaddress', option, true, false), // 新增收件人
  updatedeliveryaddress: option =>
    request('v1/deliveryaddress/updatedeliveryaddress', option, true, false), // 修改收件人地址
  deletedeliveryaddress: option => {
    const urls = querystring(option)
    return request('v1/deliveryaddress/deletedeliveryaddress' + urls, {}, true, false) //  删除收件人地址
  },
  getprovinces: option => request('v1/area/getprovinces', option, true, false), // 查询省份列表
  getcitys: option => request('v1/area/getcitys', option, true, false), // 查询城市列表
  getareas: option => request('v1/area/getareas', option, true, false), // 查询区（县）列表
  getcitytree: option => request('v1/area/getcitytree', option, true, false) // 查询省市树结构
}
